var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFill1Copy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.633 4c0-2.208 1.703-4 3.798-4 2.097 0 3.799 1.794 3.799 4 0 2.208-1.703 4-3.799 4S3.633 6.207 3.633 4m.95 0c0 1.654 1.276 3 2.848 3 1.572 0 2.85-1.345 2.85-3S9.003 1 7.43 1c-1.57 0-2.848 1.345-2.848 3M7.43 18c-2.827 0-4.905-.282-6.25-.861-.842-.363-1.322-1.303-1.144-2.242l.369-1.949c.29-1.529 1.504-2.671 2.978-2.803C4.464 10.049 5.813 10 7.43 10c1.62 0 2.968.049 4.048.145 1.475.132 2.689 1.274 2.978 2.803l.37 1.948c.177.94-.303 1.881-1.145 2.243-1.346.58-3.423.861-6.25.861m0-1c2.714 0 4.684-.267 5.89-.787.422-.181.662-.651.573-1.121l-.37-1.949c-.206-1.091-1.073-1.907-2.127-2.002-1.05-.094-2.373-.141-3.967-.141-1.593 0-2.917.047-3.966.141-1.054.095-1.921.911-2.128 2.002l-.369 1.949c-.089.47.151.94.572 1.121 1.207.52 3.177.787 5.891.787",
    fill: "#313131",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFill1Copy);
export default __webpack_public_path__ + "static/media/fill-1-copy.3fcac77b808dd6b44a44f0153b9fdd76.svg";
export { ForwardRef as ReactComponent };